<script>
import validatorMixin from './validator/mixin.js';

/**
 * The base Field component, all field types should extend it.
 */
export default {
  mixins: [validatorMixin],
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isManager: {
      type: Boolean,
      default: false
    },
    foreignId: {
      type: Number,
      default: null
    },
    inActiveTab: {
      type: Boolean,
      default: false
    },
    elementId: {
      type: String,
      default: ''
    }
  },
  methods: {
    // Every time the value changes emit an 'input' event - add support for v-model
    onInput(value) {
      this.$emit('input', value);
      this.$emit('update:value', value);
    },
    getId() {
      return this.field.slug + '-' + this.elementId;
    }
  }
};
</script>
